import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ExCircleIconSvg from './icon-ex-circle.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ExCircleIconSvg {...validProps} />;
}
SvgComponent.iconName = 'stop-circleIcon';

export const ExCircleIcon = svgIconWrapper(SvgComponent);
